
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingDetailsDialog extends _Ext.ItemEditorDialog<SKUSplittingDetailsRow> {

        protected getFormKey() { return SKUSplittingDetailsForm.formKey; }
        protected getLocalTextPrefix() { return SKUSplittingDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return SKUSplittingDetailsRow.deletePermission; }
        protected getInsertPermission() { return SKUSplittingDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SKUSplittingDetailsRow.updatePermission; }
        public Closing: boolean;
        public AtbId: number;
        protected form = new SKUSplittingDetailsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions(); 
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();

            q.hideEditorLabel(this.form.ItemsDetails);
            q.setGridEditorHeight(this.form.ItemsDetails, 300)
            q.hideEditorToolbar(this.form.ItemsDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NewSKU);
            q.setTextRightAlign(this.form.NewGrossWeight);
            q.setTextRightAlign(this.form.NewStoneWeight);
            q.setTextRightAlign(this.form.NewNetWeight);
            q.setTextRightAlign(this.form.AllotedPieces);
            q.setTextRightAlign(this.form.AllotedWeight);
            q.setTextRightAlign(this.form.AllotedNetWeight);
            q.setTextRightAlign(this.form.BalancePieces);
            q.setTextRightAlign(this.form.BalanceWeight);
            q.setTextRightAlign(this.form.BalanceNetWeight);
            q.setTextRightAlign(this.form.NewSKU);

            this.form.ProductTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.BrandId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.CollectionId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.SuperTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.NewSKU.changeSelect2(e => { 
                var pieces = this.form.NewSKU.value;
                var balancepieces = this.form.BalancePieces.value;
                if (pieces > balancepieces) {
                    q.Alert('', 'Cannot be greater than Balance Pieces', 2999, false);
                    return;
                }

                this.form.NewGrossWeight.value = 0;
                this.form.NewNetWeight.value = 0;
                this.form.NewStoneWeight.value = 0;
            });
            this.form.NewGrossWeight.changeSelect2(e => {
                var grossweight = this.form.NewGrossWeight.value;
                var balanceweight = this.form.BalanceWeight.value;
                if (grossweight > balanceweight) {
                    q.Alert('', 'Cannot be greater than Balance Weight', 2999, false);
                    this.form.NewGrossWeight.value = 0;
                    return;
                }

                this.form.NewNetWeight.value = 0;
                this.form.NewStoneWeight.value = 0;
                this.form.NewNetWeight.value = grossweight;
            })
            this.form.NewStoneWeight.changeSelect2(e => {
                var newstoneweight = this.form.NewStoneWeight.value;
                var newgrossweight = this.form.NewGrossWeight.value;
                if (newstoneweight > newgrossweight) {
                    q.Alert('', 'Cannot be greater than Gross Weight', 2999, false);
                    this.form.NewStoneWeight.value = 0;
                    return;
                }
                this.form.NewNetWeight.value = newgrossweight - newstoneweight;
            });
            this.form.NewNetWeight.changeSelect2(e => {
                var newnetweight = this.form.NewNetWeight.value;
                var newstoneweight = this.form.NewStoneWeight.value;
                var newgrossweight = this.form.NewGrossWeight.value;
                if (newnetweight > newgrossweight) {
                    q.Alert('', 'Cannot be greater than Gross Weight', 2999, false);
                    this.form.NewStoneWeight.value = 0;
                    return;
                }
                this.form.NewStoneWeight.value = newgrossweight - newnetweight;
            });
            this.form.GenerateSKU.onClick = (e) => {
                var baseitemid = this.form.ProductTypeId.value == undefined ? 0 : this.form.ProductTypeId.value;
                var typeid = this.form.CategoryId.value == undefined ? 0 : this.form.CategoryId.value;
                var subtypeid = this.form.SubCategoryId.value == undefined ? 0 : this.form.SubCategoryId.value;
                var brandid = this.form.BrandId.value == undefined ? 0 : this.form.BrandId.value;
                var collectionid = this.form.CollectionId.value == undefined ? 0 : this.form.CollectionId.value;
                var supertypeid = this.form.SuperTypeId.value == undefined ? 0 : this.form.SuperTypeId.value;
                var designid = this.form.DesignId.value == undefined ? 0 : this.form.DesignId.value;
                if (baseitemid == "" || typeid == "" || subtypeid == ""
                    || brandid == "" || collectionid == "" || supertypeid == "" || designid == "") {
                    Q.alert('All Attributes need to be selected');
                    this.form.NewSKU.value = 0;
                    this.form.NewGrossWeight.value = 0;
                    this.form.NewNetWeight.value = 0;
                    this.form.NewGrossWeight.value = 0;
                    return;
                }

                this.entity.ProductTypeId = parseInt(baseitemid.toString());
                this.entity.CategoryId = parseInt(typeid.toString());
                this.entity.SubCategoryId = parseInt(subtypeid.toString());
                this.entity.BrandId = parseInt(brandid.toString());
                this.entity.CollectionId = parseInt(collectionid.toString());
                this.entity.SuperTypeId = parseInt(supertypeid.toString());
                this.entity.DesignId = parseInt(designid.toString());
                var _entity = this.entity;


                _entity.Pieces = this.form.NewSKU.value;
                _entity.Weight = this.form.NewGrossWeight.value;
                _entity.NetWeight = this.form.NewNetWeight.value;
                _entity.StoneWeight = this.form.NewGrossWeight.value - this.form.NewNetWeight.value;
                _entity.UnitRate = this.entity.UnitRate;
                
                var exchangerate = (this.parentEditor.parentDialog as SKUSplittingDialog).form.ExchRate.value;
                var transdate = new Date( (this.parentEditor.parentDialog as SKUSplittingDialog).form.TransDate.value);
                if (this.form.ItemsDetails.getItems().length > 0) {
                    var AllowSKUSplitting = q.ToBool(TabAurous.GetConfigValue(1009)); 
                    var _productId = 0;
                    if (this.form.NewProductCode.value != "")
                        _productId = parseInt(this.form.NewProductId.value);
                    else
                        _productId = this.entity.ProductId;
                    if (AllowSKUSplitting) {
                        this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, this.form.NewSKU.value, this.entity.StockId, exchangerate, transdate);
                    }
                    else {
                        var pcs = this.form.Pieces.value - this.form.ItemsDetails.getItems().length;
                        if (pcs >= this.form.NewSKU.value)
                            this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, this.form.NewSKU.value, this.entity.StockId, exchangerate, transdate);
                        else if (pcs <= this.form.NewSKU.value)
                            this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, pcs, this.entity.StockId, exchangerate, transdate);
                        else
                            Q.notifyError('Invalid Value(New SKU) should be less than Pieces');
                    }

                } else {
                    var AllowSKUSplitting = q.ToBool(TabAurous.GetConfigValue(1009));  
                    var _productId = 0;
                    if (this.form.NewProductCode.value != "")
                        _productId = parseInt(this.form.NewProductId.value);
                    else
                        _productId = this.entity.ProductId;
                    if (AllowSKUSplitting) {
                        this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, this.form.NewSKU.value, this.entity.StockId, exchangerate, transdate);
                    }
                    else {
                        if (this.form.NewSKU.value <= this.form.Pieces.value)
                            this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, this.form.NewSKU.value, this.entity.StockId, exchangerate, transdate);
                        else
                            Q.notifyError('Invalid Value(New SKU) should be less than Pieces');
                    }
                }
                this.form.NewSKU.element.focus;
                this.calculateAllocation();
            };

            var fieldEditor: JQuery = this.form.NewProductCode.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.AttributeId.value != "") {
                this.AtbId = parseInt(this.form.AttributeId.value);
            }
            this.calculateAllocation();
        }
        checkAttribute() {
            var baseitemid = parseInt(this.form.ProductTypeId.value) == undefined ? 0 : parseInt(this.form.ProductTypeId.value);
            var typeid = parseInt(this.form.CategoryId.value) == undefined ? 0 : parseInt(this.form.CategoryId.value);
            var subtypeid = parseInt(this.form.SubCategoryId.value) == undefined ? 0 : parseInt(this.form.SubCategoryId.value);
            var brandid = parseInt(this.form.BrandId.value) == undefined ? 0 : parseInt(this.form.BrandId.value);
            var collectionid = parseInt(this.form.CollectionId.value) == undefined ? 0 : parseInt(this.form.CollectionId.value);
            var supertypeid = parseInt(this.form.SuperTypeId.value) == undefined ? 0 : parseInt(this.form.SuperTypeId.value);

            var attributeid;
            OMS.CommonAttributesService.GetProductATB({

                ProductTypeId: baseitemid,
                CategoryId: typeid,
                SubCategoryId: subtypeid,
                BrandId: brandid,
                CollectionId: collectionid,
                SuperTypeId: supertypeid

            }, response => {
                attributeid = response.AttributeId
            }, { async: false }
            );
            if (attributeid.length > 0) {
                this.AtbId = attributeid[0].AttributeId;
            }
            else {
                this.AtbId = 0;
            }

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.ItemsDetails.getItems();
            var totalweight = this.form.Weight.value;
            var totalpieces = this.form.Pieces.value;
            var newweight = 0;
            var newpieces = 0;
            for (var i = 0; i < items.length; i++) {
                newweight += items[i].Weight;
                newpieces += items[i].Pieces;
            }
            if (totalweight < newweight) {
                Q.alert('Total Weights do not match');
                return false;
            } else if (totalweight == newweight && totalpieces > newpieces) {
                Q.alert('All weight canot be consumed');
                return false;
            } else
                return true;
        }

        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = Common.ProductSelectGrid;
                var producttypeid = parseInt(this.form.ProductTypeId.value);
                var filters: _Ext.SelectGridFilters = {
                    ProductTypeId: producttypeid,
                    FilterItems: 5
                }
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select New Product", GridFilters: filters
                });


                pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
                    if (selectedItems.length > 0) {
                        var product = selectedItems[0]
                        this.form.NewProductId.value = product.ProductId.toString();
                        this.form.NewProductCode.value = product.ProductCode;
                        this.form.BrandId.value = product.BrandId.toString();
                        this.form.CollectionId.value = product.CollectionId.toString();
                        this.form.SuperTypeId.value = product.SuperTypeId.toString();
                        this.form.CategoryId.value = product.CategoryId.toString();
                        this.form.SubCategoryId.value = product.SubCategoryId.toString();
                        this.form.ProductTypeId.value = product.ProductTypeId.toString();
                        this.checkAttribute();

                    }
                }
                pickerDialog.dialogOpen();
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        calculateAllocation() {
            var items = this.form.ItemsDetails.getItems();
            var pcs = 0; var wt = 0; var nwt = 0;
            for (var i = 0; i < items.length; i++) {
                pcs += items[i].Pieces;
                wt += items[i].Weight;
                nwt += items[i].NetWeight;

            }
            this.form.AllotedPieces.value = pcs;
            this.form.AllotedWeight.value = wt;
            this.form.AllotedNetWeight.value = nwt;

            this.form.BalancePieces.value = this.form.Pieces.value - pcs;
            this.form.BalanceWeight.value = this.form.Weight.value - wt;
            this.form.BalanceNetWeight.value = this.form.NetWeight.value - nwt;
        }
    }
}